import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class LastVisitorsService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetList(dateDuration): Promise<any> {
        return this.baseApiFactory.getData<any[]>(`/api/LastVisitors?dateDuration=${dateDuration}`);
    }
}

lazyRegister.service('LastVisitorsService', LastVisitorsService);

